import { render, staticRenderFns } from "./bad_debt.vue?vue&type=template&id=70483cbf&scoped=true&"
import script from "./bad_debt.vue?vue&type=script&lang=js&"
export * from "./bad_debt.vue?vue&type=script&lang=js&"
import style0 from "./bad_debt.vue?vue&type=style&index=0&id=70483cbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70483cbf",
  null
  
)

export default component.exports